import { AccountACL } from '../../shared/constants/account-acl.constants';

export interface IAccount {
  name: string;
  lastname: string;
  lang: string;
}

/**
 * User account model
 */
export class Account implements IAccount {
  constructor(
    public name: string,
    public lastname: string,
    public lang: string,
    public accountId: string,
    public userType: string,
    public acls: AccountACL[]
  ) {}
}


/**
 * Account update model, used just for update info about user
 */
export class AccountUpdate implements IAccount {
  constructor(
    public name: string,
    public lastname: string,
    public lang: string
  ) {

  }
}
